import * as React from 'react';
import { useState } from 'react';
import SimpleTable from 'src/components/common/SimpleTable/SimpleTable';
import classNames from 'classnames';
import styles from '../assets/payroll-list.module.scss';
import DeletePayrollAction from './DeletePayrollAction';
import { Paginated } from 'src/services/api-handlers/pagination';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';

import ModalComponent from 'src/components/modals/ModalComponent';

import { changeToZeroMoment } from 'src/helpers/timeHelpers';

import { IProvider } from 'src/types/provider';
import { IPayroll } from '../../../../../../../../../types/payroll';
import GeneralEnumService from 'src/enumerables/general-enum';
import { Link } from 'react-router-dom';
import Router from '../../../../../../../../../navigation/router';
import { routes } from '../../../../../../../../../navigation';
import user from 'src/services/user-auth';
import UserRole from '../../../../../../../../../enumerables/user-role';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { numberWithCommas } from '../../../../../../../../../helpers/format';
import { QueryParams } from '../../../../../../../../../types/grid';

export interface StateProps {}
export interface DispatchProps {}

export interface OwnProps {
    provider: Partial<IProvider> | null;
    data: Paginated<IPayroll>;
    getData: (params: QueryParams) => void;
    updatePayroll: ({ status, id, setPopup }: any) => void;
    month: { monthEnd: string; monthStart: string };
}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const PayrollTable: React.FunctionComponent<Props> = ({ updatePayroll, data, provider, month, getData }: Props) => {
    const [formColumn, setFormColumn] = useState<any>(false);
    const [popup, setPopup] = useState<boolean>(false);
    const [openDrop] = useState<boolean>(false);

    const [currentDeChangeId, setId] = useState<string | number>(0);

    const dataSessionComponents: any = [];

    const entityModal: any = {
        CHANGE_STATUS: {
            action: () => updatePayroll({ status: +3, id: currentDeChangeId, setPopup }),
            body: <div>Are you sure you want to pay Payroll?</div>,
        },
    };

    const { totalPages, page } = data;
    let totalAmount = 0;
    data.list.forEach((itSes: any) => {
        totalAmount += itSes.totalPaid ? +itSes.totalPaid : 0;

        const GeneralEnum = GeneralEnumService ? GeneralEnumService.getEnum('PayrollStatus') : {};
        const statusItems: SelectObject[] = getValFromEnum(GeneralEnum);
        let valueStatus: any = statusItems.find((it) => it.value === itSes.status);
        valueStatus = valueStatus ? valueStatus.label : '';
        dataSessionComponents.push({
            ...itSes,
            id: itSes.id,
            action: (
                <div className={styles.btnWrap}>
                    <Link
                        className={'btn ml-3 mr-1 btn-outline-info'}
                        to={Router.generate(routes.PROVIDER_DETAIL, {
                            id: itSes?.provider?.id,
                            tab: 'payrolls-detail',
                            subId: itSes.id,
                        })}
                    >
                        <FontAwesomeIcon icon={faSearch} />
                    </Link>
                    {itSes.status !== 3 && user.getRoles().includes(UserRole.ROLE_ADMIN) ? (
                        <div className={classNames(styles.btnIn)}>
                            <button
                                className={classNames('bg-primary btn  rounded text-white', 'ml-2 mr-3')}
                                type={'button'}
                                onClick={() => {
                                    setPopup(true);
                                    setId(itSes['id']);
                                }}
                            >
                                $
                            </button>

                            <DeletePayrollAction
                                getData={getData}
                                month={month}
                                provider={provider}
                                data={{ id: itSes.id }}
                            />
                        </div>
                    ) : null}
                </div>
            ),
            status: <div style={{ minWidth: 150, maxWidth: 150 }}>{valueStatus}</div>,

            payrollDate: itSes.payrollDate ? changeToZeroMoment(itSes['payrollDate'], 'MMM D, YYYY') : '',
            totalPaid: itSes.totalPaid ? `$${numberWithCommas(itSes.totalPaid)}` : '',
            periodStart: itSes.periodStart ? changeToZeroMoment(itSes['periodStart'], 'MMM D, YYYY') : '',
            periodEnd: itSes.periodEnd ? changeToZeroMoment(itSes['periodEnd'], 'MMM D, YYYY') : '',
        });
    });
    if (formColumn === true) {
    } else {
        if (totalAmount) {
            dataSessionComponents.push({
                totalPaid: `$${numberWithCommas(totalAmount)}`,
            });
        }
    }
    const isMobile = window.innerWidth <= 800;
    const noteParams = [];
    if (!isMobile) {
        noteParams.push({ id: 'note', label: 'Note', cellStyle: 'normal' });
    }
    return (
        <div className={'d-flex flex-column'}>
            <div style={openDrop ? { overflow: 'visible' } : {}} className={'responsive-table'}>
                <SimpleTable
                    action={setFormColumn}
                    data={dataSessionComponents}
                    pagination={{ page, totalPages }}
                    columns={[
                        { id: 'action', label: 'Action', cellStyle: 'normal' },
                        /*    { id: 'id', label: '#', cellStyle: 'normal' },*/
                        { id: 'payrollDate', label: 'Date', cellStyle: 'normal' },
                        { id: 'totalPaid', label: 'Payable', cellStyle: 'normal' },
                        { id: 'periodStart', label: 'Start', cellStyle: 'normal' },
                        { id: 'periodEnd', label: 'End', cellStyle: 'normal' },
                        ...noteParams,
                        { id: 'status', label: 'Status', cellStyle: 'normal' },
                    ]}
                />
                <ModalComponent
                    modal={popup}
                    setModal={setPopup}
                    dataBody={entityModal['CHANGE_STATUS']?.body}
                    action={entityModal['CHANGE_STATUS']?.action}
                />
            </div>
        </div>
    );
};

export default PayrollTable;
